import React, { useState } from 'react'
import { Tooltip } from 'reactstrap'

const RenderSpan = ({ option, rowIndex, ignoreReason }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)

  if (option === 'Ignored') {
    return (
      <React.Fragment>
        <span id={`statusToolTip${rowIndex}`} style={{ color: 'rgba(220, 53, 69, 0.65)' }}>
          {option}
        </span>
        <Tooltip placement="top" isOpen={tooltipOpen} target={`statusToolTip${rowIndex}`} toggle={toggle}>
          {ignoreReason}
        </Tooltip>
      </React.Fragment>
    )
  } else if (option === 'Inactive') {
    return (
      <span id={`statusToolTip${rowIndex}`} style={{ color: 'rgba(220, 53, 69)' }}>
        {option}
      </span>
    )
  } else {
    return <span id={`statusToolTip${rowIndex}`}>{option}</span>
  }
}

export default RenderSpan
